import { ROLES } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { hasRestrictedRole } from 'globalutils/fmUtils';
import moment from 'moment';
import React, { lazy, useState } from 'react';
import { alertColumns as columns } from './columnMapping';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`);
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const Alerts = ({ list, handleDeleteAlert, callback, i18n }) => {
  const [ModalListObject, setModalListObject] = useState(null);

  const generateRows = () => {
    const updatedList = list?.map((item) => {
      for (let i = 0; i < columns.length; i++) {
        if (columns[i].id === 'description') {
          item.description =
            item.url && checkServiceProvider('alerts_descriptionLink', window.$environment.SERVICE_PROVIDER, false) ? (
              <Link href={window.location.origin + item.url.replace('.', '')}>{item.description}</Link>
            ) : (
              item.description
            );
        }
        if (columns[i].id === 'date') {
          item.date = item.date ? moment(new Date(item.date)).format('MM/DD/YYYY HH:mm:ss') : '';
        }
      }

      return item;
    });
    return updatedList;
  };

  return (
    <>
      <Table
        type="client"
        defaultSortBy={{ sortBy: 'date', order: 'desc' }}
        title=""
        columns={columns}
        data={generateRows()}
        emptyMessage={i18n.t('common.tableEmptyMessage')}
        itemsPerPage={5}
        id="dashBoardAlerts"
        noPagination
        actions={
          !hasRestrictedRole([ROLES.VIEW_ONLY_FM])
            ? [
                {
                  icon: (row) => {
                    return (
                      <Icon
                        className={layout === 'SpireonNew' ? 'sp-icon-delete' : ''}
                        src={mediaUrls?.deleteIcon}
                        onClick={() => {
                          setModalListObject({
                            content: () => (
                              <div className="deleteParent">
                                <div className="imageSection">
                                  <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
                                </div>
                                <h2> {i18n.t('common.sureConfirm')} </h2>
                                <div className="deletePopupBtn">
                                  <div className="cancelBtn">
                                    <Button
                                      label={i18n.t('common.cancel')}
                                      type={'reset'}
                                      onClick={() => {
                                        setModalListObject(null);
                                      }}
                                    ></Button>
                                  </div>
                                  <div className="deletebtn">
                                    <Button
                                      label={i18n.t('common.deletePopup')}
                                      onClick={() => {
                                        handleDeleteAlert({
                                          apiId: 'deleteAlert',
                                          data: {
                                            data: { id: row?.id },
                                          },
                                          callback,
                                        });
                                        setModalListObject(null);
                                      }}
                                    ></Button>
                                  </div>
                                </div>
                              </div>
                            ),
                          });
                        }}
                      />
                    );
                  },
                },
              ]
            : []
        }
        i18n={i18n}
      />
      {ModalListObject && (
        <Modal.default open={!!ModalListObject} setOpen={() => setModalListObject(null)} data={ModalListObject} deletePopup />
      )}
    </>
  );
};

export default Alerts;

Alerts.defaultProps = {};
